<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover;">
        <!-- Header -->
        <Header></Header>
        <!-- Menu -->
        <v-layout justify-center>
            <v-flex xs12 style="background-color: #527281">
                <v-content>
                    <v-layout px-12 py-3>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
                                หน้าแรก
                            </v-btn>
                        </v-flex>
                        <v-icon style="color: white">play_arrow</v-icon>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px"
                                   @click="$router.push('/order-history').catch(err => {})">ประวัติการสั่งซื้อ
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-content>
            </v-flex>
        </v-layout>
        <!-- Table Oder History -->
        <v-layout>
            <v-flex mb-12>
                <v-layout justify-center>
                    <v-flex class="mt-12 mb-6" style="font-size: 28px; font-weight: bold;color: #D97C57;">
                        รายการการสั่งซื้อทั้งหมด
                    </v-flex>
                </v-layout>
                <v-layout justify-center class="table-search">
                    <v-flex shrink xs12 class="mx-12 mb-4">
                        <v-card>
                            <template>
                                <v-data-table
                                        :headers="headers"
                                        :items="orders.data"
                                        class="elevation-1"
                                        :hide-default-footer="true"
                                >
                                    <template v-slot:item.med_spec.name_th="{ item }">
                                        <v-flex ml-4 style="text-align: left;">
                                            {{item.med_spec.name_th}}
                                        </v-flex>
                                    </template>

                                    <template v-slot:item.order="{ item }">
                                            <v-icon style="color: #D97C57">attach_file</v-icon>
                                    </template>
                                    <template v-slot:item.status="{ item }">
                                        <v-flex>
                                            <span @click="editStatus(item.id)"
                                                  style="color: #D97C57;cursor: pointer;text-decoration: underline">{{item.status  === '1' ? 'ใช้งาน' : 'ยกเลิก'}}</span>
                                        </v-flex>
                                    </template>
                                </v-data-table>
                            </template>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-pagination
                        :length="paginations.last_page"
                        :total-visible="9"
                        v-model="paginations.current_page"
                        @input="getPagination"
                ></v-pagination>
            </v-flex>
        </v-layout>

        <!-- เมื่อคลิกใช้งานในคอลัมน์สถานะ -->
        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span style="font-weight: bold">แก้ไขสถานะการสั่งพิมพ์</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-flex xs12 class="dialog-detail">
                                    <v-layout>
                                        <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                                            เลขที่เอกสาร :
                                        </v-flex>
                                        <v-flex xs8>
                                            <v-text-field
                                                    v-model="form_dialog.noData"
                                                    background-color="#E5E5E5"
                                                    item-color="#84A2A8"
                                                    solo
                                                    readonly
                                                    required>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                                            วันที่ :
                                        </v-flex>
                                        <v-flex xs8>
                                            <v-text-field
                                                    v-model="form_dialog.time"
                                                    background-color="#E5E5E5"
                                                    value=""
                                                    item-color="#84A2A8"
                                                    solo
                                                    readonly
                                                    required>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                                            เวลา :
                                        </v-flex>
                                        <v-flex xs8>
                                            <v-text-field
                                                    v-model="form_dialog.date"
                                                    background-color="#E5E5E5"
                                                    value=""
                                                    item-color="#84A2A8"
                                                    solo
                                                    readonly
                                                    required>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                                            ชื่อ สป. :
                                        </v-flex>
                                        <v-flex xs8>
                                            <v-text-field
                                                    v-model="form_dialog.nameSp"
                                                    background-color="#E5E5E5"
                                                    value=""
                                                    item-color="#84A2A8"
                                                    solo
                                                    readonly
                                                    required>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                                            สถานะ :
                                        </v-flex>
                                        <v-flex xs8 class="pl-3">
                                            <v-radio-group v-model="form_dialog.status" :mandatory="false" class="ma-0 pa-0">
                                                <v-row>
                                                    <v-radio label="ใช้งาน" value="1" class="pa-0 ma-0"></v-radio>
                                                    <v-radio label="ยกเลิก" value="0" class="ml-4"></v-radio>
                                                </v-row>
                                            </v-radio-group>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-layout class="mb-4" justify-center>
                                <v-flex shrink class="ma-2">
                                    <v-btn style="background-color: #BDBDBD; color: white;border-radius: 25px;" @click="dialog = false">ย้อนกลับ</v-btn>
                                </v-flex>
                                <v-flex shrink class="ma-2">
                                    <v-btn style="background-color: #527281; color: white;border-radius: 25px;" @click="updateStatus">ยืนยันการแก้ไข</v-btn>
                                </v-flex>
                            </v-layout>
<!--                            <div class="flex-grow-1"></div>-->
<!--                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>-->
<!--                            <v-btn color="blue darken-1" text @click="dialog = false">Save</v-btn>-->
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <!-- Footer -->
        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import { mapState, mapActions } from "vuex";

    export default {
        name: "OrderHistory",
        components: {
            Footer,
            Header,
        },
        created() {
            this.$store.dispatch('Common/clearOrder')
            this.getOrderAll({
                user_id: this.user.id,
                page: this.paginations.current_page,
            });
        },
        computed: {
            // Map Vuex state.
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                orders: state => {
                    return state.Common.order;
                },
                paginations: state => {
                    return state.Common.pagination;
                },
            })
        },
        data: () => ({
            form_dialog: {
                id: null,
                noData: '',
                date: '',
                time: '',
                nameSp: '',
                status: '',
            },
            dialog: false,
            // status: '',
            headers: [
                {text: 'เลขที่เอกสาร', value: 'order_id', sortable: true, align: 'center', width: "1%"},
                {text: 'วันที่', value: 'created_date', sortable: true, align: 'center', width: "1%"},
                {text: 'เวลา', value: 'created_time', sortable: false, align: 'center', width: "1%"},
                {text: 'ชื่อ สป.', value: 'med_spec.name_th', sortable: true, align: 'center', width: "10%"},
                {text: 'สั่งซื้อ', value: 'order', sortable: false, align: 'center', width: "1%"},
                {text: 'สถานะ', value: 'status', sortable: true, align: 'center', width: "1%"}
            ],
            data_order_all: [],
            data_order: [],
        }),

        methods: {
            ...mapActions('Common', [
                'getOrderAll'
            ]),
            editStatus(id) {
                this.dialog = true;
                this.$store.dispatch('Common/getOrder', id).then(data => {
                    this.form_dialog.id = data.id;
                    this.form_dialog.noData = data.order_id;
                    this.form_dialog.date = data.created_date;
                    this.form_dialog.time = data.created_time;
                    this.form_dialog.nameSp = data.med_spec.name_th;
                    this.form_dialog.status = data.status;
                })
            },
            updateStatus() {
                let data = {
                    id: this.form_dialog.id,
                    status: this.form_dialog.status,
                }
                // console.log(data)
                this.$store.dispatch('Common/updateStatusOrder', data).then(res => {
                    alert('อัพเดตสถานะเรียบร้อยแล้ว')
                    // console.log(res)
                    this.dialog = false;
                    location.reload();
                    // this.getOrder();
                })
                //     .catch(err => {
                //     alert('อัพเดตสถานะไม่สำเร็จ')
                // })
            },

            // Pagination
            getPagination(page) {
                // console.log(page)
                let data = {
                    user_id: this.user.id,
                    page: this.paginations.current_page,
                }
                this.$store.dispatch('Common/getOrderAll', data)

            }
        }
    }
</script>

<style lang="scss">
    .dialog-detail {
        .v-text-field.v-text-field--solo .v-input__control {
            min-height: 35px !important;
        }

        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
            border-radius: 10px;
            box-shadow: unset;
        }

        .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
            color: #527281;
        }

        .theme--light.v-select .v-select__selections {
            color: #527281;
        }

        .theme--light.v-select:hover {
            color: #527281;
        }

        .v-icon.v-icon {
            color: #527281 !important;
            caret-color: #527281 !important;
        }

        .v-text-field.v-text-field--enclosed .v-text-field__details {
            margin-bottom: 0;
        }

        .v-input__slot {
            margin-bottom: 0;
        }

        .v-menu__content.theme--light.menuable__content__active {
            text-align: left !important;
        }
    }
    .theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
        color: rgba(255, 255, 255, 0.38)!important;
    }
    .theme--light.v-data-table .v-data-table-header th.sortable.active, .theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon, .theme--light.v-data-table .v-data-table-header th.sortable:hover {
        color: rgba(255, 255, 255, 0.87)!important;
    }
</style>
